export const CompanyFeatureKey = 'company';
